namespace Ir.Components.Workbook.Widgets.FunnelWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: any;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        let widget: FunnelWidget = params.widget;
        widget.set$ReportContent(componentInfo.element);
        widget.setup();
    }
}